(() => {
  const storageKey = 'dekor365-cart-expiry';

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function startTimer(element) {
    if (element.dataset.timerInitialized === 'true') return;

    const timer = element.querySelector('[data-cart-expiry-timer]');
    if (!timer) return;

    const durationMinutes = parseInt(element.dataset.durationMinutes || '10', 10);
    const now = Date.now();
    const storedExpiry = parseInt(window.localStorage.getItem(storageKey) || '0', 10);
    const expiry = storedExpiry > now ? storedExpiry : now + durationMinutes * 60 * 1000;

    if (storedExpiry <= now) {
      window.localStorage.setItem(storageKey, String(expiry));
    }

    const update = () => {
      const remainingMs = Math.max(expiry - Date.now(), 0);
      const totalSeconds = Math.floor(remainingMs / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      timer.textContent = `${pad(minutes)}:${pad(seconds)}`;
    };

    update();
    window.setInterval(update, 1000);
    element.dataset.timerInitialized = 'true';
  }

  function moveBannerIntoCart(root) {
    const banner = root.querySelector('[data-cart-expiry-banner-root]');
    const cartItems = document.querySelector('.main-cart cart-items.cart-items-box');
    const cartForm = cartItems?.querySelector('form.cart__contents');
    const section = banner?.closest('.shopify-section');

    if (!banner || !cartItems || !cartForm) return;
    if (banner.parentElement === cartItems) return;

    cartItems.insertBefore(banner, cartForm);

    if (section) {
      section.classList.add('cart-expiry-banner-dekor--mounted');
    }
  }

  function init(root = document) {
    root.querySelectorAll('[data-cart-expiry-banner]').forEach(startTimer);
    moveBannerIntoCart(root);
  }

  document.addEventListener('DOMContentLoaded', () => {
    init(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
